/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/29/21
 * Copyright All Rights Reserved
 */
import React from 'react';
import classNames from 'classnames';
import BasicReduxFormSelectMenu from 'components/support/forms/SelectMenus/BasicReduxFormSelectMenu';
import RenderInput from 'components/support/forms/RenderInput';
import {
  PROBABALISTIC_ANALYSIS,
  SCENARIO_WITH_FULL_UNCERTAINTY,
  SCENARIO_FOR_EVENT_SHAKEMAP,
} from 'constants/analysisTypes';

const items = [
  {
    id: PROBABALISTIC_ANALYSIS,
    name: 'Probabilistic Analysis',
    value: PROBABALISTIC_ANALYSIS,
  },
  {
    id: SCENARIO_WITH_FULL_UNCERTAINTY,
    name: 'Scenario Analysis (with full uncertainty)',
    value: SCENARIO_WITH_FULL_UNCERTAINTY,
  },
  {
    id: SCENARIO_FOR_EVENT_SHAKEMAP,
    name: 'Scenario Analysis (for event shake map)',
    value: SCENARIO_FOR_EVENT_SHAKEMAP,
    disabled: true,
  },
];
const AnalysisTypeSelectMenu = () => (
  <BasicReduxFormSelectMenu
    includeEmptyOption={false}
    items={items}
    id="analysisType"
    name="analysisType"
    inputClassName={classNames('custom-select', 'analysis-type-select')}
    component={RenderInput}
  />
);

export default AnalysisTypeSelectMenu;



// WEBPACK FOOTER //
// ./js/components/pages/Inventory/InventoryPageControlForm/AnalysisTypeSelectMenu/index.jsx